const types = {
	//Get Template name
	GET_CLIENT_EVALUATION_START: "GET_CLIENT_EVALUATION_START",
	GET_CLIENT_EVALUATION_SUCCESS: "GET_CLIENT_EVALUATION_SUCCESS",
	GET_CLIENT_EVALUATION_ERROR: "GET_CLIENT_EVALUATION_ERROR",
	GET_CLIENT_EVALUATION_RESET: "GET_CLIENT_EVALUATION_RESET",

	//Create Template name
	CREATE_CLIENT_EVALUATION_START: "CREATE_CLIENT_EVALUATION_START",
	CREATE_CLIENT_EVALUATION_SUCCESS: "CREATE_CLIENT_EVALUATION_SUCCESS",
	CREATE_CLIENT_EVALUATION_ERROR: "CREATE_CLIENT_EVALUATION_ERROR",
	CREATE_CLIENT_EVALUATION_RESET: "CREATE_CLIENT_EVALUATION_RESET",

	//delete Template name
	DELETE_CLIENT_EVALUATION_START: "DELETE_CLIENT_EVALUATION_START",
	DELETE_CLIENT_EVALUATION_SUCCESS: "DELETE_CLIENT_EVALUATION_SUCCESS",
	DELETE_CLIENT_EVALUATION_ERROR: "DELETE_CLIENT_EVALUATION_ERROR",
	DELETE_CLIENT_EVALUATION_RESET: "DELETE_CLIENT_EVALUATION_RESET",

	//update Template name
	UPDATE_CLIENT_EVALUATION_START: "UPDATE_CLIENT_EVALUATION_START",
	UPDATE_CLIENT_EVALUATION_SUCCESS: "UPDATE_CLIENT_EVALUATION_SUCCESS",
	UPDATE_CLIENT_EVALUATION_ERROR: "UPDATE_CLIENT_EVALUATION_ERROR",
	UPDATE_CLIENT_EVALUATION_RESET: "UPDATE_CLIENT_EVALUATION_RESET",

	//single item  name
	SINGLE_CLIENT_EVALUATION_START: "SINGLE_CLIENT_EVALUATION_START",
	SINGLE_CLIENT_EVALUATION_SUCCESS: "SINGLE_CLIENT_EVALUATION_SUCCESS",
	SINGLE_CLIENT_EVALUATION_ERROR: "SINGLE_CLIENT_EVALUATION_ERROR",
	SINGLE_CLIENT_EVALUATION_RESET: "SINGLE_CLIENT_EVALUATION_RESET",
};

export default types;
